import React, { useMemo } from "react";
import GenericListPage from "../../pages/GenericListPage";

const BusinessAdminSubscriptionsPage = () => {
  const columns = useMemo(() => [
    { header: "User", key: "customer_name" },
    { header: "Email", key: "customer_email" },
    { header: "Plan", key: "subscription_plan" },
    { header: "Start Date", key: "startDate", render: (item) => new Date(item.start_at).toLocaleDateString() },
    { header: "End Date", key: "endDate", render: (item) => new Date(item.end_at).toLocaleDateString() },
    { header: "Status", key: "status" },
    { header: "Organization", key: "organizationName" },
  ], []);

  return (
    <GenericListPage
      title="All Subscriptions"
      entityEndpoint="business-admin/subscriptions"
      columns={columns}
      hideActions={true}
      filterConfig={[
        { label: "Email", name: "userEmail", type: "text", placeholder: "User Email" },
        { label: "Plan", name: "subscription_plan", type: "text", placeholder: "Plan Name" },
        { label: "Status", name: "status", type: "select", options: [
          { label: "All", value: "" },
          { label: "Active", value: "active" },
          { label: "Expired", value: "expired" },
          { label: "Cancelled", value: "cancelled" },
        ]},
      ]}
    />
  );
};

export default BusinessAdminSubscriptionsPage;